<template>
	<v-row>
		<v-col cols="12" md="4" xl="3" v-for="offer in homeOffers" :key="offer.id">
			<offer-card :offer="offer" :isOnboarding="isOnboarding" />
		</v-col>

		<v-col cols="12">
			<v-row class="fill-height" v-if="!isLoading && homeOffers.length == 0">
				<v-col cols="12">
					<div
						class="d-flex flex-column fill-height align-center justify-center py-16"
					>
						<div class="text-h5 font-weight-medium text-center">
							No Home Offers found
						</div>
						<v-btn
							depressed
							small
							tile
							color="secondary"
							class="text-none py-6 px-8 mt-8"
							@click="fetchHomeOffers"
							>Refresh</v-btn
						>
						<v-btn
							depressed
							v-if="isOnboarding"
							small
							tile
							color="primary"
							class="text-none py-6 px-8 mt-4"
							@click="$router.push({ name: 'dashboard.index' })"
							>Proceed to Dashboard</v-btn
						>
					</div>
				</v-col>
			</v-row>
			<v-row v-if="isLoading">
				<v-col cols="12" sm="6" md="4" xl="3" v-for="i in 8" :key="i">
					<v-skeleton-loader
						:max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
						:width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
						v-bind="attrs"
						height="350"
						type="image, article, actions"
					></v-skeleton-loader>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	import OfferCard from "@/components/homes/OfferCard.vue";
	import { TransactionService } from "@/services/index.js";

	export default {
		components: {
			OfferCard,
		},
		props: {
			isOnboarding: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				isLoading: false,
				homeOffers: [],
				attrs: {
					class: "mb-6",
					boilerplate: true,
					elevation: 0,
				},
			};
		},
		methods: {
			async fetchHomeOffers() {
				try {
					this.isLoading = true;

					const {
						data: packageList,
					} = await TransactionService.getHousePackages();

					this.homeOffers = packageList;
				} catch (error) {
					this.isLoading = false;
				} finally {
					this.isLoading = false;
				}
			},
		},
		mounted() {
			this.fetchHomeOffers();
		},
	};
</script>
